export default function checkUpDown(today, yesterday) {
  if (isNaN(yesterday)) {
    return true;
  } else {
    return today > yesterday;
  }
}
